import React from 'react';
import { Star, CheckCircle2 } from 'lucide-react';
export function SocialProofSection() {
  return <section className="px-4 py-10 max-w-md mx-auto" data-id="element-149">
      <div className="text-center mb-8" data-id="element-150">
        <h2 className="text-2xl font-bold text-darkslate mb-2" data-id="element-151">
          El Desafío de los 7 Días
        </h2>
        <p className="text-gray-600 text-sm" data-id="element-152">
          Resultados reales de personas que ya resetearon su metabolismo.
        </p>
      </div>

      <div className="space-y-4" data-id="element-153">
        <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100" data-id="element-154">
          <div className="flex items-center gap-2 mb-2" data-id="element-155">
            <div className="flex text-yellow-400" data-id="element-156">
              <Star className="w-4 h-4 fill-current" data-id="element-157" />
              <Star className="w-4 h-4 fill-current" data-id="element-158" />
              <Star className="w-4 h-4 fill-current" data-id="element-159" />
              <Star className="w-4 h-4 fill-current" data-id="element-160" />
              <Star className="w-4 h-4 fill-current" data-id="element-161" />
            </div>
            <span className="text-xs text-gray-500 flex items-center gap-1" data-id="element-162">
              <CheckCircle2 className="w-3 h-3 text-green-500" data-id="element-163" /> Compra
              verificada
            </span>
          </div>
          <p className="text-sm text-gray-700 italic mb-3" data-id="element-164">
            "Hacía dieta y no bajaba un gramo. Empecé a aplicar la rutina
            nocturna y los suplementos que recomiendan. En 7 días me deshinche
            un montón y volví a dormir de corrido. Increíble."
          </p>
          <p className="text-xs font-bold text-darkslate" data-id="element-165">
            — Mariana L., 34 años
          </p>
        </div>

        <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100" data-id="element-166">
          <div className="flex items-center gap-2 mb-2" data-id="element-167">
            <div className="flex text-yellow-400" data-id="element-168">
              <Star className="w-4 h-4 fill-current" data-id="element-169" />
              <Star className="w-4 h-4 fill-current" data-id="element-170" />
              <Star className="w-4 h-4 fill-current" data-id="element-171" />
              <Star className="w-4 h-4 fill-current" data-id="element-172" />
              <Star className="w-4 h-4 fill-current" data-id="element-173" />
            </div>
            <span className="text-xs text-gray-500 flex items-center gap-1" data-id="element-174">
              <CheckCircle2 className="w-3 h-3 text-green-500" data-id="element-175" /> Compra
              verificada
            </span>
          </div>
          <p className="text-sm text-gray-700 italic mb-3" data-id="element-176">
            "Pensé que era otro plan de dieta más, pero la lista del súper y
            entender cómo funciona el cortisol me cambió la cabeza. Ya no vivo
            con esa sensación de pesadez."
          </p>
          <p className="text-xs font-bold text-darkslate" data-id="element-177">
            — Diego F., 41 años
          </p>
        </div>
      </div>
    </section>;
}